import { Filter } from 'src/utils/composeFilter.ts';

export const showFailSafeAttr = (filter: Filter) => {
    const Family = filter.Family || [];
    return !(Family.includes('Fail-safe') || Family.includes('Non fail-safe'));
};
